import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EnvironmentInjector, inject } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { ImageScrollAnimationDirective } from 'src/app/shared/directives/image-scroll-animation.directive';
import { ResponsiveService } from 'src/app/shared/services/responsive.service';
import * as environment from '../../core/appSettings';
import { PeopleListSwiperComponent } from './people-swiper/people-list-swiper/people-list-swiper.component';
@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, ImageScrollAnimationDirective, PeopleListSwiperComponent],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent {
  constructor(
    private injector: EnvironmentInjector,
    private translocoService: TranslocoService,
    private cdr: ChangeDetectorRef
  ) {

  }
  protected responsiveService = inject(ResponsiveService);


  public readonly isMobile$: Observable<boolean> = this.responsiveService.isMobile$;
  ;

  public tabs: any = [
  ]


  ngOnInit(): void {
    // Set initial logo based on current language
    this.translocoService.langChanges$.subscribe(lang => {
      let nbglogo = lang == 'en' ? './assets/svgs/nbg-logo-black-en.svg' : './assets/svgs/nbg-logo-black.svg';
      let nbglogoWhite = lang == 'en' ? './assets/svgs/nbg-logo-white-en.svg' : './assets/svgs/nbg-logo-white.svg';
      this.tabs = [
        {
          description: 'coop.tab.qualco',
          img: ['./assets/svgs/Qualco_Logo_White.svg', './assets/svgs/Qualco_Logo_Blue.svg'],
          alt: 'qualco logo'
        },
        {
          description: 'coop.tab.nbg',
          img: [nbglogoWhite, nbglogo],
          alt: 'nbg logo'
        }]
      this.cdr.detectChanges();
    });

  }
  public readonly values = [
    {
      title: 'ourValues.accordion.title1',
      description: 'ourValues.accordion.description1',
      img: './assets/img/transparency-checked.png'
    },
    {
      title: 'ourValues.accordion.title2',
      description: 'ourValues.accordion.description2',
      img: './assets/img/goal.png'
    },
    {
      title: 'ourValues.accordion.title3',
      description: 'ourValues.accordion.description3',
      img: './assets/img/honesty.png'
    }
  ]



  public readonly swiperItems = [
    {
      title: 'Δήμητρα Παπαδοπούλου',
      description: 'Διευθύνουσα Σύμβουλος',
      img: 'https://via.placeholder.com/204x224'
    },
    {
      title: 'Γιώργος Ιωακειμίδης',
      description: 'Τεχνικός Διευθυντής',
      img: 'https://via.placeholder.com/204x224'
    },
    {
      title: 'Θάνος Γερασιμίδης',
      description: 'Επικεφαλής Μάρκετινγκ',
      img: 'https://via.placeholder.com/204x224'
    },
    {
      title: 'Μαρία Βουδούρη',
      description: 'Επικεφαλής πληροφορικής',
      img: 'https://via.placeholder.com/204x224'
    },
    {
      title: 'Μαρία Βουδούρη',
      description: 'Επικεφαλής πληροφορικής',
      img: 'https://via.placeholder.com/204x224'
    },
    {
      title: 'Μαρία Βουδούρη',
      description: 'Επικεφαλής πληροφορικής',
      img: 'https://via.placeholder.com/204x224'
    }, {
      title: 'Μαρία Βουδούρη',
      description: 'Επικεφαλής πληροφορικής',
      img: 'https://via.placeholder.com/204x224'
    }, {
      title: 'Μαρία Βουδούρη',
      description: 'Επικεφαλής πληροφορικής',
      img: 'https://via.placeholder.com/204x224'
    }, {
      title: 'Μαρία Βουδούρη',
      description: 'Επικεφαλής πληροφορικής',
      img: 'https://via.placeholder.com/204x224'
    },
  ];

  public readonly isProduction = environment.getAppSettings(this.injector).production;

  selectedTab: number = 1; // Initial state

  currentAccordionIndex: number | null = null; // Tracks the currently open accordion index

  toggleAccordion(index: number) {
    // Close the currently open accordion if it's clicked again, otherwise open the new one
    this.currentAccordionIndex = this.currentAccordionIndex === index ? null : index;
  }

  toggleSwitch(index: number) {
    this.selectedTab = index;
  }
}
